import React from 'react';
import { useTranslation } from '@shared/core';
import { InfoTooltip } from '@shared/components/InfoTooltip';

interface BookingAssistantTooltipProps
  extends Readonly<{
    children: React.ReactNode;
  }> {}

export const BookingAssistantTooltip: React.FC<BookingAssistantTooltipProps> = ({ children }) => {
  const { tq } = useTranslation('stayBookingAssistant');

  return (
    <InfoTooltip
      title={tq`What's Booking Assistant?`}
      description={tq`We find nearby hotel deals for your guests—no need to list or choose hotels yourself. Customize how the hotels appear on your page.`}
      autoOpen={true}
      userConsentKey="hasSeenBookingAssistantTooltip"
    >
      {children}
    </InfoTooltip>
  );
};
